/**
 * @author Michael Hasenstein <hasenstein@yahoo.com>
 * @copyright REFINIO GmbH 2017
 * @license CC-BY-NC-SA-2.5; portions MIT License
 * @version 0.0.1
 */
import { getUint8Array } from '../util/buffer.js';
import { ensurePlatformLoaded } from './platform.js';
function getCS() {
    const cs = globalThis.__ONE_CORE_CRYPTO_CS__;
    if (!cs) {
        throw new Error('CS not initialized - platform not loaded');
    }
    return cs;
}
export function setPlatformForCs(exports) {
    globalThis.__ONE_CORE_CRYPTO_CS__ = exports;
}
/**
 * @static
 * @param {Uint8Array | ArrayBufferLike} password
 * @param {Uint8Array | ArrayBufferLike} salt
 * @param {number} [N=1024]
 * @param {number} [r=8]
 * @param {number} [p=1]
 * @param {number} [dkLen=32]
 * @returns {Promise<Uint8Array>}
 */
export async function scrypt(password, salt, N = 1024, r = 8, p = 1, dkLen = 32) {
    ensurePlatformLoaded();
    return await getCS().scrypt(getUint8Array(password), getUint8Array(salt), N, r, p, dkLen);
}
/**
 * @static
 * @param {string} secret
 * @param {Uint8Array | ArrayBufferLike} salt
 * @param {number} [len=32]
 * @returns {Promise<Uint8Array>}
 */
export async function deriveBinaryKey(secret, salt, len = 32) {
    ensurePlatformLoaded();
    return await getCS().deriveBinaryKey(secret, getUint8Array(salt), len);
}
//# sourceMappingURL=crypto-scrypt.js.map